import {AxiosInstance} from 'axios';
import {responseHandler} from './response';
import {ApiSportsEndPointResponse} from "./types";
import {ReferralCodeCheck, ReferralSummary} from "../../types/referral";

export const getMyReferrals = async (client: AxiosInstance) =>
    responseHandler<ApiSportsEndPointResponse<ReferralSummary>>(client.get('/referrals/me'))

/** Public endpoint: usable from the signup form, before the account exists */
export const validateReferralCode = async (client: AxiosInstance, code: string) => {
    client.defaults.params = {code}
    return responseHandler<ApiSportsEndPointResponse<ReferralCodeCheck>>(client.get('/referrals/validate'))
}
